export default "__VITE_ASSET__BIW2jlR1__"